export default __webpack_public_path__ + "static/media/transfer.c70f6223.svg";